import {CircularProgress} from '@mui/material';
import {updateCampaignSource, useDashboardDetails} from '../../api';
import {ApiError} from '../../common/ApiError';
import {EditFormLayoutBuilder} from './components/EditFormLayoutBuilder';

import {APIResponse, APIResponseType, CampaignInfo, WebsiteStructure} from '../../api/models';
import {useContext, useEffect, useState} from 'react';
import {AuthContext} from '../../api/context';
import Percept from '@perceptinsight/percept-js';


export const DashboardScreen = () => {
    const context = useContext(AuthContext);
    const [websiteData, updateWebsiteData] = useState<APIResponse | undefined>(undefined);
    const {data, error, isLoading, isSuccess, isError, refetch} = useDashboardDetails();
    const [campaignSourceDetails, setCampaignSourceDetails] = useState<CampaignInfo | undefined>(undefined);

    useEffect(() => {
        if (campaignSourceDetails) {
            if (campaignSourceDetails.campaignSource || campaignSourceDetails.campaignId) {
                updateCampaignSource(campaignSourceDetails);
                Percept.capture('SOCIALMART-LOGIN', { 
                    campaignSource: campaignSourceDetails.campaignSource,
                    campaignId: campaignSourceDetails.campaignId,
                    userId: context?.userDetails?.id
                });
                localStorage.removeItem('campaignSource');
                localStorage.removeItem('campaignId');
            }
        }
    }, [campaignSourceDetails?.campaignSource, campaignSourceDetails?.campaignId]);

    useEffect(() => {
        const fetchAndUpdateUserDetails = async () => {
            const sessionDetails = await context?.fetchSessionDetails();
            if (sessionDetails) {
                context?.setUserDetails(sessionDetails);
            }
        };

        if (context?.userDetails) {
            context.setUserDetails(context.userDetails);
        } else {
            fetchAndUpdateUserDetails();
        }
        setCampaignSourceDetails({
            campaignSource: localStorage.getItem('campaignSource') || '',
            campaignId: localStorage.getItem('campaignId') || '',
        });
    }, [context]);

    useEffect(() => {
        if (data) {
            updateWebsiteData(data);
        }
    }, [data]);

    if (isLoading) {
        return (
            <div>
                <CircularProgress />
            </div>
        );
    } else if (isError) {
        return <ApiError title={error.name} subtitle={error.message} onButtonClick={refetch} />;
    } else if (isSuccess && websiteData !== undefined) {
        if (websiteData.type === APIResponseType.WebsiteStructure) {
            return (
                <div>
                    <EditFormLayoutBuilder data={websiteData.data as WebsiteStructure} refetch={() => refetch()} />
                </div>
            );
        } else {
            return <></>;
        }
    } else {
        return <div></div>;
    }
};
